export default [
  {
    title: 'breadcrumb.operator',
    icon: 'UsersIcon',
    children: [
      {
        title: 'breadcrumb.operator',
        route: 'list-operator',
        icon: '',
        resource: 'manage-users',
        action: 'read'
      },
      {
        title: 'breadcrumb.rolePermission',
        route: 'list-role',
        icon: '',
        resource: 'manage-role',
        action: 'read'
      },
    ],
  },
];